import http from 'conversations-http/clients/http';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import * as ContactsAPI from 'crm_data/contacts/api/ContactsAPI';
export const fetchContactByEmail = ({
  email
}) => ContactsAPI.fetchByEmail(email).then(contactsMap => contactsMap.first());
export const fetchContactByVid = vid => http.get(`contacts/v1/contact/vid/${vid}/profile`);